export enum LogoutMode {
  Manual = 'Manual',
  SessionTimeout = 'Session Timeout'
}
